import React, { forwardRef, memo } from 'react';
import { bool, node, number, oneOf, string } from 'prop-types';
import classnames from 'classnames';
import useStyles from './useStyles';

import './Scrollbar.scss';

const Scrollable = forwardRef(
  (
    {
      padding = 7,
      overflowWidth = 7,
      direction = 'vertical',
      isVisible = true,
      isScrollable = true,
      children,
      className = '',
      scrollbarClassName = '',
      style,
      ScrollProps,
    },
    ref
  ) => {
    const styles = useStyles({
      padding,
      overflowWidth,
      isVisible,
      isScrollable,
    });

    const wrapperClasses = classnames(
      {
        [styles.ScrollableWrapper__horizontal]: direction === 'horizontal' || direction === 'both',
        [styles.ScrollableWrapper__vertical]: direction === 'vertical' || direction === 'both',
      },
      className,
      'Scrollbar',
      scrollbarClassName
    );

    return (
      <div className={wrapperClasses} ref={ref} style={style} {...ScrollProps}>
        {children}
      </div>
    );
  }
);

Scrollable.propTypes = {
  padding: number, // padding horyzontalny dla wrappera, paddingRight zależny od overflowWidth
  overflowWidth: number, // szerokość scrollbara
  isVisible: bool, // jeśli jest false to scrollbarWidth = 0
  direction: oneOf(['horizontal', 'vertical', 'both']),
  isScrollable: bool,
  children: node,
  className: string,
  scrollbarClassName: string, // można opcjonalnie stylować poprzez wrapperClassName, ale może zaburzyć to czytelność
};

export default memo(Scrollable);
